<template>
	<ListItem
		is-recipient
	>
		<template #text>
			<div>{{text}}</div>
			<div class="mt-2">
				<Button
					text="Zugangsdaten (Link) senden"
					icon="key-chain"
					@click="$emit('sendAccessLink')"
				/>
			</div>
		</template>
	</ListItem>
</template>

<script>
import ListItem from "@/vue/communication/conversation/message/ListItem.vue";
import Button from "@/vue/common/Button.vue";

export default {
	components: {
		Button,
		ListItem
	},

	computed: {
		text ()
		{
			return 'Bitte schicke so bald wie möglich die Zugangsdaten an die Person!';
		}
	}
}
</script>
